const ActionType = {
    Create: "Create" as const,
    Update: "Update" as const
};

export default ActionType;
